import { Pipe, PipeTransform } from '@angular/core';

// Angular's built-in `date` pipe only accepts a fixed GMT offset (e.g. '+0200') as its
// timezone argument — it silently falls back to the host's own local offset for an IANA
// zone name like 'Europe/Oslo', since it parses the string with `Date.parse`. Using
// `Intl.DateTimeFormat` directly is the only way to get a real, DST-aware IANA conversion.
const OSLO_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Oslo',
  day: '2-digit',
  month: '2-digit',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

@Pipe({ name: 'osloDate', standalone: true })
export class OsloDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) return '';

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';

    const parts = OSLO_FORMATTER.formatToParts(date);
    const get = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
    return `${get('day')}.${get('month')}.${get('year')}, ${get('hour')}:${get('minute')}`;
  }
}
